import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ShiftFormService } from 'app/shared/services/data/shift/shift-form.service';
import { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';

@Component({
  selector: 'app-shift-form',
  templateUrl: './shift-form.component.html',
  styleUrls: ['./shift-form.component.scss']
})
export class ShiftFormComponent implements OnInit {
  public readonly DEFAULT_COLORS: string[] = ['#A8D0E6', '#C1E1C1', '#FFF1A8', '#F8C8DC', '#D7BDE2']

  public activeModal: NgbActiveModal

  public shiftForm: FormGroup

  @Input() public formOption: 'CREATE' | 'UPDATE'
  @Input() public title: string
  @Input() public name: string
  @Input() public start: string
  @Input() public end: string
  @Input() public color: string
  @Input() public submitText: string

  @Output() public onSubmit: EventEmitter<FormGroup> = new EventEmitter<FormGroup>()

  /**
   * Constructor
   *
   * @param {ShiftFormService} shiftFormService
   * @param {NgbActiveModal} ngbActiveModal
   * 
  */
  constructor(
    private shiftFormService: ShiftFormService,
    private ngbActiveModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.initializeValues()
  }

  private initializeValues(): void {
    this.activeModal = this.ngbActiveModal

    this.createShiftForm()
  }
  2
  private createShiftForm(): void {
    this.shiftForm = this.shiftFormService.createShiftForm(this.name, this.start, this.end, this.color)
  }

  private fireSwalAlert(options: SweetAlertOptions): Promise<SweetAlertResult> {
    return this.shiftFormService.fireSwalAlert(options)
  }

  public onFormSubmit(): void {
    const shiftForm = this.shiftForm

    const html = this.shiftFormService.createSubmitText(this.formOption, shiftForm)

    const alertOptions: SweetAlertOptions = {
      title: '¿Estás Seguro?',
      html: html,
      icon: 'warning',
      showDenyButton: true,
      denyButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar',
      customClass: {
        confirmButton: 'btn btn-success',
        denyButton: 'btn red-bg text-white ml-1'
      }
    }

    this.fireSwalAlert(alertOptions)
      .then((result) => {
        if (result.isConfirmed) this.onSubmit.emit(shiftForm)
      })
  }
}
